import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import StreamDescriptionView from "./streamDescriptionView";
import StreamDetailView from "./streamDetailView";
import { fetchStream, fetchStreamAnalytics, fetchStreamChildren, recordStreamViewed } from "../../redux/actions/streams";
import EmptyMessage from "src/components/emptyMessage";

import _ from "lodash";
import styles from "./stream.module.scss";
import { useStreamsAdoption } from "src/redux/actions/adoption/streams";
import EventService from "src/services/event.service";
import { CONTENT_HUB } from "src/constants/adoption/sourceTypes";

const emptyMessage = '/images/Unauthorized_Asset.svg';

const StreamView: React.FC = () => {

  const dispatch = useDispatch();
  const { trackStreamViewed, trackStreamDetailViewed } = useStreamsAdoption();

  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const source = searchParams.get('source');
  const sourceType = source?.split("/")[0];

  const stream = useSelector((state: any) => state.stream);
  const errorMessage = _.get(stream, `items[${id}].errors.errors`, null);

  const [isExpanded, setIsExpanded] = useState(false);


  useEffect(() => {
    if (id && !_.get(stream, `items[${id}]`)) {
      dispatch(fetchStream({ id }));
      dispatch(fetchStreamAnalytics({ id }));

      var event = {
        type: "STREAM_VIEWED",
      };
      dispatch(recordStreamViewed({id, event}));
    }
    if(EventService.triggerEventForSource(sourceType)){
      trackStreamViewed({sourceCta: sourceType || CONTENT_HUB});
      trackStreamDetailViewed({sourceCta: sourceType || CONTENT_HUB});
    }
  }, [id]);

  const handleExpandContainer = (isExpanded: boolean) => {
    setIsExpanded(isExpanded);
  }

  const renderError = () => {
    if (errorMessage && errorMessage.length) {
      const error = errorMessage[0];

      if (error.code === 10002) {
        return (
          <div className={styles.emptyContainer}>
          <EmptyMessage
            width={450}
            heading="Sorry!  Some one passed you the wrong information. You were never supposed to see me :). The stream in me does not exist any longer."
            image={emptyMessage}
          />
          </div>
        );
      } else if (error.code === 10007) {
        return (
          <div className={styles.emptyContainer}>
          <EmptyMessage    
            width={450}
            heading= "I’m sorry! It seems like I’m not authorised to show what you are looking for. I hate disappointing you :("
            image={emptyMessage}
          />
          </div>
        );
      }
    }
    return null;
  };

  if (errorMessage) {
    return renderError();
  }

  return (
    <div className={styles.container}>
      <StreamDescriptionView id={id || ''} handleExpandContainer={handleExpandContainer} />
      <StreamDetailView id={id || ''} isExpanded={isExpanded} />
    </div>
  );
};

export default StreamView;
